(function () {

    var baseUrl = "https://biogaia.infolyzer.se";
    var assetsBaseUrl = `${baseUrl}/assets`;
    var apiBaseUrl = `${baseUrl}/api`;
    var quizzesBaseUrl = `${baseUrl}/quizzes/quizzes`;

    var version = Date.now().toString();

    results = {};
    quizContainers = document.querySelectorAll("[data-quiz-id]");

    quizContainers.forEach(async quizContainer => {
        var quizId = quizContainer.getAttribute("data-quiz-id");
        var response = await fetch(`${quizzesBaseUrl}/${quizId}/quiz.json?v=${version}`);
        var quizData = await response.json();
        quizHandler.init(quizId, quizData, quizContainer);
    });

    function _init(quizId, quizData, quizContainer) {
        var pageContainer = _createDiv("bgq-page-container");
        quizContainer.appendChild(pageContainer);
        var startPage = createStartPage(quizId, quizData, pageContainer);
        pageContainer.appendChild(startPage);

        for (var i = 0; i < quizData.questions.length; i++) {
            var questionPage = createQuestionPage(quizId, quizData, i, pageContainer)
            pageContainer.appendChild(questionPage);
        }

        var finishPage = createFinishPage(quizId, quizData, pageContainer);
        pageContainer.appendChild(finishPage);
    }

    function _resetPagePosition(page) {
        setTimeout(() => {
            page.classList.add("reset");
        }, 100);
        setTimeout(() => {
            page.classList.remove("hide");
            page.classList.remove("reset");
            page.classList.remove("show");
        }, 100);
    }

    async function _start(quizId, quizData, pageContainer) {
        results[quizId] = {
            answers: [],
            average: 0,
            respondents: 0
        };
        var startPage = pageContainer.querySelector(".page.start");
        startPage.classList.add("hide");
        _resetPagePosition(startPage);
        var questionPages = pageContainer.querySelectorAll(".page.question");
        var firstPage = questionPages[0];
        firstPage.classList.add("show");

        var response = await fetch(`${apiBaseUrl}/get.php?quiz-id=${quizId}`);
        var stats = await response.json();

        results[quizId].average = parseInt(stats.average);
        results[quizId].respondents = parseInt(stats.respondents);
    }

    function _reset(quizId, quizData, pageContainer) {
        var options = pageContainer.querySelectorAll(".page.question .option");
        options.forEach(option => {
            option.setAttribute("class", "option active");
        });
        var dots = pageContainer.querySelectorAll(".page .dot-container > .dot");
        dots.forEach(d => {
            d.setAttribute("class", "dot");
        });
        var nextButtons = pageContainer.querySelectorAll(".page.question > .panel.right button");
        nextButtons.forEach(btn => {
            btn.setAttribute("style", null);
        });

        // Reset page positions
        var startPage = pageContainer.querySelector(".page.start");
        var finishPage = pageContainer.querySelector(".page.finish");
        var questionPages = pageContainer.querySelectorAll(".page.question");

        for (var i = 0; i < questionPages.length; i++) {
            questionPages[i].setAttribute("class", "page question");
            var questionText = questionPages[i].querySelector(".question-text");
            questionText.innerHTML = quizData.questions[i].question;
            questionPages[i].querySelector(".question-container").classList.remove("explanation");
        }

        startPage.setAttribute("class", "page start");

        finishPage.classList.add("hide");
        _resetPagePosition(finishPage);
        startPage.classList.add("show");
    }

    function _createDiv(classNames) {
        var div = document.createElement("div");
        if (classNames) {
            var classes = classNames.split(" ");
            classes.forEach(c => div.classList.add(c));
        }
        return div;
    }

    function createStartPage(quizId, quizData, pageContainer) {
        var page = _createDiv("page start show");
        var leftPanel = _createDiv("panel left");
        page.appendChild(leftPanel);
        var imageUrl = `${quizzesBaseUrl}/${quizId}/${quizData.startPage.mediaUrl}`
        leftPanel.style.backgroundImage = `url("${imageUrl}")`;
        var leftPanelContent = _createDiv();
        leftPanel.appendChild(leftPanelContent);

        var preTitle = _createDiv("heading");
        preTitle.innerText = "Take the quiz";
        leftPanelContent.appendChild(preTitle);

        var quizTitle = _createDiv("quiz-title");
        quizTitle.innerText = quizData.startPage.title;
        leftPanelContent.appendChild(quizTitle);

        var rightPanel = _createDiv("panel right");
        page.appendChild(rightPanel);
        var rightPanelContent = _createDiv();
        rightPanel.appendChild(rightPanelContent);

        quizData.startPage.text.forEach(part => {
            var p = document.createElement("p");
            p.innerHTML = part;
            rightPanelContent.appendChild(p);
        });

        var btn = document.createElement("button");
        btn.innerText = "Start the quiz"
        rightPanel.appendChild(btn);
        btn.addEventListener("click", async () => {
            await quizHandler.start(quizId, quizData, pageContainer);
        });

        return page;
    }

    function createQuestionPage(quizId, quizData, questionIndex, pageContainer) {
        var questionData = quizData.questions[questionIndex];
        var page = _createDiv("page question");
        var leftPanel = _createDiv("panel left");
        page.appendChild(leftPanel);
        var mediaUrl = `${quizzesBaseUrl}/${quizId}/${questionData.media.url}`
        if (questionData.media.type === "image") {
            leftPanel.style.backgroundImage = `url("${mediaUrl}")`;
        } else {
            // video
        }
        var rightPanel = _createDiv("panel right");
        page.appendChild(rightPanel);
        var rightPanelContent = _createDiv();
        rightPanel.appendChild(rightPanelContent);

        var title = _createDiv("title");
        rightPanelContent.appendChild(title);
        title.innerText = `QUESTION: ${questionIndex + 1}`;

        var questionContainer = _createDiv("question-container");
        rightPanelContent.appendChild(questionContainer);
        var questionText = _createDiv("question-text");
        questionContainer.appendChild(questionText);
        questionText.innerHTML = questionData.question;

        if (questionData.readMore) {
            var readMore = _createDiv("read-more");
            rightPanelContent.appendChild(readMore);
            readMore.innerHTML = _renderReadMore(questionData.readMore);
        }

        var optionContainer = _createDiv("option-container");
        rightPanelContent.appendChild(optionContainer);
        var i = 1;
        questionData.alternatives.forEach(alternative => {
            var option = _createDiv("option active");
            optionContainer.appendChild(option);
            option.setAttribute("data-alternative", i);
            var radioButton = _createDiv("radio-button");
            option.appendChild(radioButton);
            var optionText = _createDiv("option-text");
            option.appendChild(optionText);
            optionText.innerHTML = alternative;

            option.addEventListener("click", function () {
                // Prevent further clicks on this optionContainer after the first click (until reset)
                if (page.classList.contains("answered")) {
                    return;
                }
                page.classList.add("answered");

                var selectedAlternative = parseInt(this.getAttribute("data-alternative"));
                var correct = selectedAlternative === questionData.correctAlternative;

                // record the answer
                results[quizId].answers.push(correct);

                // mark correct/incorrect
                setTimeout(() => {
                    optionContainer.querySelectorAll(".option").forEach(op => {
                        op.classList.remove("active");
                        var opIndex = parseInt(op.getAttribute("data-alternative"));
                        if (opIndex === questionData.correctAlternative) {
                            op.classList.add("correct");
                        } else {
                            op.classList.add("incorrect");
                        }
                    });
                    _updateProgress(page, results[quizId].answers);

                    questionContainer.classList.add("explanation");
                    questionText.innerHTML = correct
                        ? questionData.explanations.correctAnswer
                        : questionData.explanations.wrongAnswer;

                    page.querySelector(".page.question > .panel.right button").style.display = "block";
                }, 250);

                option.classList.add("selected");
            });

            i++;
        });

        var dotContainer = _createDiv("dot-container");
        rightPanel.appendChild(dotContainer);
        quizData.questions.forEach(() => {
            var dot = _createDiv("dot");
            dotContainer.appendChild(dot);
        });

        var btn = document.createElement("button");
        btn.innerText = questionIndex < quizData.questions.length - 1
            ? "Next"
            : "Finish";
        rightPanel.appendChild(btn);
        btn.addEventListener("click", async () => {
            page.classList.add("hide");
            _resetPagePosition(page);
            if (questionIndex < quizData.questions.length - 1) {
                var questionPages = pageContainer.querySelectorAll(".page.question");
                var nextPage = questionPages[questionIndex + 1];
                nextPage.classList.add("show");
                _updateProgress(nextPage, results[quizId].answers);
            } else {
                var finishPage = pageContainer.querySelector(".page.finish");
                finishPage.classList.add("show");
                _updateProgress(finishPage, results[quizId].answers);
                await _updateResult(finishPage, results[quizId], quizId);
            }
        });

        return page;
    }

    function createFinishPage(quizId, quizData, pageContainer) {
        var page = _createDiv("page finish");
        var content = _createDiv("content");
        page.appendChild(content);

        var title = _createDiv("title");
        content.appendChild(title);
        title.innerText = "RESULTS";

        var dotContainer = _createDiv("dot-container");
        content.appendChild(dotContainer);
        quizData.questions.forEach(() => {
            var dot = _createDiv("dot");
            dotContainer.appendChild(dot);
        });

        var yourScore = _createDiv("score-container your-score");
        content.appendChild(yourScore);
        var yourScoreLabel = _createDiv();
        yourScoreLabel.innerText = "Your score:";
        yourScore.appendChild(yourScoreLabel);
        yourScore.appendChild(_createDiv()); // result placeholder, will be populated later

        var averageScore = _createDiv("score-container average-score");
        content.appendChild(averageScore);
        var averageScoreLabel = _createDiv();
        averageScoreLabel.innerText = "Average score:";
        averageScore.appendChild(averageScoreLabel);
        averageScore.appendChild(_createDiv()); // result placeholder, will be populated later

        var text = _createDiv("text");
        content.appendChild(text);
        quizData.finishPage.text.forEach(part => {
            var p = document.createElement("p");
            p.innerHTML = part;
            text.appendChild(p);
        });

        if (quizData.finishPage.readMore) {
            var readMore = _createDiv("read-more");
            content.appendChild(readMore);
            readMore.innerHTML = _renderReadMore(quizData.finishPage.readMore);
        }

        var btn = document.createElement("button");
        btn.innerText = "Take the quiz again"
        page.appendChild(btn);
        btn.addEventListener("click", () => {
            quizHandler.reset(quizId, quizData, pageContainer);
        });

        return page;
    }


    var replaceLinkIndex;

    function _renderReadMore(readMoreData) {
        replaceLinkIndex = 0;
        return readMoreData.text.replace(/({{)([^}}]+)(}})/g, function (match) {
            var linkText = match.substr(2, match.length - 4);
            var url = readMoreData.links[replaceLinkIndex++];
            return `<a href="${url}" target="_blank" class="read-more">${linkText}</a>`;
        });
    }

    function _updateProgress(page, answers) {
        var dots = page.querySelectorAll(".dot-container > .dot");
        for (var i = 0; i < answers.length; i++) {
            dots[i].classList.add(answers[i] ? "correct" : "incorrect");
        }
    }

    async function _updateResult(finishPage, result, quizId) {
        var correctAnswers = result.answers.filter(a => a === true).length;
        var yourScore = finishPage.querySelector(".your-score > div:last-child");
        var yourScorePercentage = Math.round(correctAnswers / result.answers.length * 100);
        yourScore.innerText = `${correctAnswers}/${result.answers.length} (${yourScorePercentage}%)`;

        var averageScore = finishPage.querySelector(".average-score > div:last-child");

        var averagePercentage = Math.round((yourScorePercentage + result.average * result.respondents) / (result.respondents + 1));
        var averagePoints = Math.round(averagePercentage / 100 * result.answers.length);
        averageScore.innerText = `${Math.round(averagePoints)}/${result.answers.length} (${averagePercentage}%)`;

        await _postResult({
            quizId,
            correctAnswers,
            numberOfQuestions: result.answers.length,
            answersJson: JSON.stringify({ answers: result.answers })
        })
    }

    async function _postResult(data) {
        try {
            var response = await fetch(`${apiBaseUrl}/post.php`, {
                method: "POST",
                headers: {
                },
                body: JSON.stringify(data),
            });
            const result = await response.json();
            //console.log("Success:", result);
        } catch (error) {
            //console.error("Error:", error);
        }
    }

    quizHandler = window.quizHandler || {
        init: _init,
        start: _start,
        reset: _reset
    };

})();
